import { Button } from "@chakra-ui/react";
import { AiFillPrinter } from "react-icons/ai";
import { useNavigate } from "react-router-dom";

export function PrintGraphsButton() {
  const navigate = useNavigate();

  return (
    <Button onClick={() => navigate("/printGraphs")} leftIcon={<AiFillPrinter />} colorScheme="brand">
      Print Graphs
    </Button>
  );
}
